import React from "react";
import { InvoiceRootScreenContext } from "./context";

export const useInvoiceRootScreenContextProvider = () => {
  const context = React.useContext(InvoiceRootScreenContext);
  if (!context) {
    throw new Error("No InvoiceRootScreenContext context was provided.");
  }
  return context;
};
